// extracted by mini-css-extract-plugin
export default {"root":"MagicLink_root__NTZO7","verticalCenter":"MagicLink_verticalCenter__UdJgf"};